"use strict";

import Feature from "ol/Feature";

gc.gis.factory.OLFactory = function()
{
	gc.gis.factory.ObjectFactory.call(this);

	this._geometryFactory = new gc.gis.geom.OLGeometryFactory();
};
gc.gis.factory.OLFactory.prototype = Object.create(gc.gis.factory.ObjectFactory.prototype);


/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createMap = function(holder, options)
{
	return new gc.gis.OLMap(holder, options);
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createGeometry = function(geometry)
{
	return this._geometryFactory.createGeometry(geometry);
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createPoint = function(opt_point)
{
	return this._geometryFactory.createPoint(opt_point);
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createLineString = function(opt_linestring)
{
	return this._geometryFactory.createLineString(opt_linestring);
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createLinearRing = function(opt_linearring)
{
	return this._geometryFactory.createLinearRing(opt_linearring);
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createPolygon = function(opt_polygon)
{
	return this._geometryFactory.createPolygon(opt_polygon);
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createCircle = function(opt_circle)
{
	return this._geometryFactory.createCircle(opt_circle);
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createMultiPoint = function(opt_multipoint)
{
	return this._geometryFactory.createMultiPoint(opt_multipoint);
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createMultiLineString = function(opt_multiline)
{
	return this._geometryFactory.createMultiLineString(opt_multiline);
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createMultiPolygon = function(opt_multipolygon)
{
	return this._geometryFactory.createMultiPolygon(opt_multipolygon);
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createGeometryCollection = function (opt_collection)
{
	return this._geometryFactory.createGeometryCollection(opt_collection);
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createFeature = function(opt_feature)
{
    if (!opt_feature) {
        opt_feature = new Feature();
	}
	return new gc.gis.feature.OLFeature(opt_feature);
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createFormat = function ()
{
	return new gc.gis.format.OLFormat();
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createGeometryProcessor = function ()
{
	return new gc.gis.geom.OLGeometryProcessor();
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createTrackingLayer = function(map)
{
	return new gc.gis.layer.OLTrackingLayer(map);
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createLayer = function( holder, options )
{
	if( holder )
	{
		if( holder instanceof gc.gis.layer.GCGroupLayer )
		{
			return this.createLayerGroup( holder, options );
		}
		else if( holder instanceof gc.gis.layer.GCVectorLayer )
		{
			return this.createVectorLayer( holder, options );
		}
		else if( holder instanceof gc.gis.layer.GCRasterLayer )
		{
			return this.createRasterLayer( holder, options );
		}
		else
		{
			throw new gc.gis.error.GCError('Unsupported layer type');
		}
	}
	else
	{
		throw new gc.gis.error.GCError('Failed to create layer: Could not determine layer type.');
	}
};

gc.gis.factory.OLFactory.prototype.createLayerGroup = function( holder, options )
{
	//return new gc.gis.OL3LayerGroup( holder, options );
};

gc.gis.factory.OLFactory.prototype.createVectorLayer = function( holder, options )
{
	//return new gc.gis.OL3VectorLayer( holder, options );
};

gc.gis.factory.OLFactory.prototype.createRasterLayer = function( holder, options )
{
	//return new gc.gis.OL3RasterLayer( holder, options );
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createMapDrawInteraction  = function(map, opt_options)
{
    return new gc.gis.map.OLMapDrawInteraction(map, opt_options);
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createMapTransformInteraction  = function(map, opt_options)
{
	return new gc.gis.map.OLMapTransformInteraction(map, opt_options);
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createWMSProvider = function(requestManager, map)
{
	return new gc.gis.OLWMSProvider(requestManager, map);
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createWFSProvider = function( options )
{
	return new gc.gis.OLWFSProvider( options );
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createWMTSProvider = function(requestManager)
{
	return new gc.gis.OLWMTSProvider(requestManager);
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createStyleFill = function()
{
    return new gc.gis.style.OLFill();
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createStyleStroke = function()
{
    return new gc.gis.style.OLStroke();
};

/**
 * @inheritDoc
 */
gc.gis.factory.OLFactory.prototype.createStyleCircle = function()
{
    return new gc.gis.style.OLCircle();
};